<div class="milestone-status m-t-20 m-b-5">
    <p-chip
      class="b3 font-medium radius-8 milestone-count-chip not-started m-r-10"
      [label]="'Not Started:' +notStarted"
    />
    <p-chip
    class="b3 font-medium radius-8 milestone-count-chip ongoing m-r-10"
    [label]="'Ongoing: ' + ongoing"
  ></p-chip>
  <p-chip
    class="b3 font-medium radius-8 milestone-count-chip completed m-r-10"
    [label]="'Completed: ' + completed"
  ></p-chip>
  
  <p-chip
    class="b3 font-medium radius-8 milestone-count-chip delayed m-r-10"
    [label]="'Delayed: ' + delayed"
  ></p-chip>
  
  <p-chip
    class="b3 font-medium radius-8 milestone-count-chip terminated m-r-10"
    [label]="'Terminated: ' + terminated"
  ></p-chip>
  </div>